export default {
	serverPath: 'https://console.movingpay.com.br/admin'
};
